import { render, staticRenderFns } from "./indicators2.vue?vue&type=template&id=1b5cf9f2&scoped=true&"
import script from "./indicators2.vue?vue&type=script&lang=js&"
export * from "./indicators2.vue?vue&type=script&lang=js&"
import style0 from "./indicators2.vue?vue&type=style&index=0&id=1b5cf9f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5cf9f2",
  null
  
)

export default component.exports